import * as React from 'react';
import { withRouter } from 'react-router-dom';
import Analytics from '../../analytics/Analytics';
import { trackPageEvent } from '../../analytics/tracking';
class Status extends React.Component {
    render() {
        const { code, history: { location: { pathname } }, children, staticContext } = this.props;
        if (staticContext)
            staticContext.statusCode = code;
        return (React.createElement(React.Fragment, null,
            pathname && (React.createElement(Analytics, { event: trackPageEvent({
                    pathname: pathname
                }) })),
            children));
    }
}
export default withRouter(Status);
//# sourceMappingURL=Status.js.map